/**
 * 从URL参数获取token的工具函数
 */

interface TokenData {
  token: string;
  user: any;
}

/**
 * 从URL参数中获取token和用户信息
 */
export function getTokenFromUrl(): TokenData | null {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    const userParam = urlParams.get("user");

    if (token) {
      let user = null;
      if (userParam) {
        try {
          user = JSON.parse(decodeURIComponent(userParam));
        } catch (e) {
          console.warn("解析用户参数失败:", e);
        }
      }

      return { token, user };
    }

    return null;
  } catch (error) {
    console.error("从URL获取token失败:", error);
    return null;
  }
}

/**
 * 将token和用户信息设置到localStorage
 */
export function setTokenToLocalStorage(tokenData: TokenData): void {
  try {
    localStorage.setItem("mslogin_token", tokenData.token);

    if (tokenData.user) {
      localStorage.setItem("mslogin_user", JSON.stringify(tokenData.user));
    }

    console.log("✅ Token已设置到localStorage");
  } catch (error) {
    console.error("设置token到localStorage失败:", error);
  }
}

/**
 * 检查并处理URL中的token
 * 如果URL中有token参数，则设置到localStorage并清理URL
 */
export function handleTokenFromUrl(): boolean {
  const tokenData = getTokenFromUrl();

  if (tokenData) {
    setTokenToLocalStorage(tokenData);

    // 清理URL参数
    const url = new URL(window.location.href);
    url.searchParams.delete("token");
    url.searchParams.delete("user");

    // 更新URL但不刷新页面
    window.history.replaceState({}, "", url.toString());

    console.log("✅ 已处理URL中的token并清理URL参数");
    return true;
  }

  return false;
}
